const PageLayoutEnum = {
  LISTING: 'listing',
  DETAILS: 'details',
  FULL_WIDTH: 'full-width',
  LISTING_IN_DETAILS: 'listing-in-details',
};
export default PageLayoutEnum;
